<template>
  <v-container style="max-width: 1800px !important;">
    <v-row style="max-width: 1800px !important;">
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
        >
          <template v-slot:[`item.fotografia`]="{ item }">
            <v-container>  
              <br>
              <v-img
                height="200"
                :src="(item.fotografia != null) ? `/api/archivos/pacientes/${item.fotografia}?jwt=${token}` : '/img/persona.jpg'"
                contain
                width="200"
              ></v-img>
            </v-container>
          </template>
          <template v-slot:[`item.nombre_completo`]="{ item }">
            {{item.nombre}} {{item.apellido_paterno}} {{item.apellido_materno}}
          </template>
          <template v-slot:[`item.signos_vitales`]="{ item }">
            <div>
              <v-icon
                color="green darken-2"
              >
                mdi-weight-kilogram
              </v-icon>
              <span class="text-body-2">
                Peso: {{ item.signos_vitales.peso }} Kg
              </span>
            </div>
            <div>
              <v-icon
                color="blue darken-2"
              >
                mdi-human-male-height-variant
              </v-icon>
              <span class="text-body-2">
                Estatura: {{ item.signos_vitales.estatura }} m
              </span>
            </div>
            <div>
              <v-icon
                color="purple darken-2"
              >
                mdi-percent-outline
              </v-icon>
              <span class="text-body-2">
                IMC: {{ item.signos_vitales.imc }}
              </span>
            </div>
            <div
              v-if="item.signos_vitales.cintura != null"
            >
              <v-icon
                color="teal darken-2"
              >
                mdi-tape-measure
              </v-icon>
              <span class="text-body-2">
                Cintura: {{ item.signos_vitales.cintura }} cm
              </span>
            </div>
            <div>
              <v-icon
                color="blue-grey darken-2"
              >
                mdi-thermometer
              </v-icon>
              <span class="text-body-2">
                Temperatura: {{ item.signos_vitales.temperatura }}° C
              </span>
            </div>
            <div>
              <v-icon
                color="red darken-2"
              >
                mdi-heart
              </v-icon>
              <span class="text-body-2">
                Pulso: {{ item.signos_vitales.pulso }} ppm
              </span>
            </div>
            <div>
              <v-icon
                color="orange darken-2"
              >
                mdi-lungs
              </v-icon>
              <span class="text-body-2">
                Respiración: {{ item.signos_vitales.respiracion }} rpm
              </span>
            </div>
            <div>
              <v-icon
                color="indigo darken-2"
              >
                mdi-counter
              </v-icon>
              <span class="text-body-2">
                Oximetría: {{ item.signos_vitales.oximetria }}% Sp02
              </span>
            </div>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <template v-if="item.en_progreso == true">
              <v-icon color="green" x-large>mdi-progress-check</v-icon>
              <span class="text-subtitle-1 green--text">En Progreso</span>
              <br>
            </template>
            <template v-if="item.nivel_urgencia == 1">
              <v-icon color="green" x-large>mdi-ambulance</v-icon>
              <span class="text-subtitle-1 green--text">Normal</span>
            </template>
            <template v-if="item.nivel_urgencia == 2">
              <v-icon color="yellow" x-large>mdi-ambulance</v-icon>
              <span class="text-subtitle-1 yellow--text">Prioridad</span>
            </template>
            <template v-if="item.nivel_urgencia == 3">
              <v-icon color="orange" x-large>mdi-ambulance</v-icon>
              <span class="text-subtitle-1 orange--text">Urgencia</span>
            </template>
            <template v-if="item.nivel_urgencia == 4">
              <v-icon color="red" x-large>mdi-ambulance</v-icon>
              <span class="text-subtitle-1 red--text">Emergencia</span>
            </template>

            <v-btn
              color="green"
              class="white--text"
              block
              @click="iniciarConsulta(item)"
            >
              Iniciar Consulta
            </v-btn>
            <br>
            <v-btn
              text
              color="red"
              block
              @click="cancelarConsulta(item)"
            >
              Cancelar Consulta
            </v-btn>
          </template>

        </v-data-table>
      </v-col>
    </v-row>
    <CancelarConsulta
      ref="cancelarConsulta"
      url="/ConsultasNutricionales/CancelarConsulta"
      @change="getConsultasNutricionales"
    >
    </CancelarConsulta>
    <consulta
      ref="consulta"
      @complete="finalizarConsulta"
    >
    </consulta>
  </v-container>
</template>

<script>
import Consulta from './ConsultaNutricional/Consulta.vue'
import axios from 'axios'
import { mapState } from 'vuex'
import CancelarConsulta from '@/components/DashViews/Comunes/CancelarConsulta.vue'

export default {
  components: {
    Consulta,
    CancelarConsulta
  },
  computed: {
    ...mapState(['token'])
  },
  data: () => ({
    headers: [
      {
        text: "Fotografia",
        value: "fotografia",
        align: "center",
        width: "10%",
        sortable: false,
      },
      {
        text: "Folio",
        value: "folio",
        align: "center",
        width: "10%",
        sortable: false,
      },
      {
        text: "Nombre Completo",
        value: "nombre_completo",
        align: "center",
        width: "15%",
        sortable: false,
      },
      {
        text: "Edad",
        value: "edad",
        align: "center",
        width: "10%",
        sortable: false,
      },
      {
        text: "Sexo",
        value: "sexo",
        align: "center",
        width: "10%",
        sortable: false,
      },
      {
        text: "Signos Vitales",
        value: "signos_vitales",
        align: "center",
        width: "15%",
        sortable: false,
      },
      {
        text: "Acciones",
        value: "actions",
        align: "center",
        width: "10%",
        sortable: false,
      },
    ],
    items: [],
    loading: false,
    countupOptions: {
      suffix: ' Consultas'
    },
    normal: 0,
    prioridad: 0,
    urgencia: 0,
    emergencia: 0
  }),
  mounted() {
    this.getConsultasNutricionales();
  },
  methods: {
    getItems(){
      this.getConsultasNutricionales();
    },
    getConsultasNutricionales(){
      this.loading = true;
      this.items = [];

      axios
      .get('/ConsultasNutricionales/ListarConsultas')
      .then(response => {
        this.items = response.data.consultas_nutricionales;
        this.consultaEnProgreso();
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        this.loading = false;
      })
    },
    consultaEnProgreso(){
      axios
      .get('/ConsultasNutricionales/ConsultaEnProgreso')
      .then(response => {
        if(response.data != null && response.data.length > 0){
          this.$refs.consulta.iniciarConsulta(response.data)
        }
      })
      .catch(error => {
        console.log(error)
      })
    },
    iniciarConsulta(item){
      this.$refs.consulta.iniciarConsulta(item.id_paciente_servicio);
      this.getConsultasNutricionales();
    },
    finalizarConsulta(){
      this.getConsultasNutricionales();
    },
    cancelarConsulta(item){
      this.$refs.cancelarConsulta.openDialog(item);
    }
  }
}
</script>